import router from '@/router'
import Router from 'vue-router'

export function useRouter(): Router {
    return router
}
